<template>
  <div class="mt-60">
    <div class="boires-page-loader-div" v-if="isLoading">
      <div class="boires-page-loader"></div>
    </div>
    <MainLayout>
      <div class="container text-left">
        <h2 class="title text-uppercase text-left mb-20">
          {{ title }}
        </h2>
      </div>

      <FilterBar
        id="filter-bar"
        :filter-count="filterCount"
        :sortable="false"
        @emit-filter-reset="emitResetFilters"
        @emit-filter-click="emitToggleFilter"
        @emit-shorting-change="shortedBy"
      />

      <div id="blogs" class="mt-16">
        <el-row>
          <mq-layout :mq="['xs', 'sm', 'md']" class="container">
            <el-col :span="24">
              <BlogCardsList
                v-if="
                  changeBlogView &&
                  blogs &&
                  blogs.results &&
                  blogs.results.length > 0
                "
                :blogs="blogs.results && blogs.results"
                :span="12"
                :list-type="viewType"
              />
              <div v-else class="text-center mt-100 no-records-found">
                <h4>
                  {{ noRecordsFound }}
                </h4>
              </div>
            </el-col>
          </mq-layout>
          <mq-layout v-if="isMounted" mq="lg+" class="container">
            <el-col :span="isFilterVisible ? 4 : 0">
              <!-- :authors-model="selectedFilters.authors" -->
              <!-- :countries-model="selectedFilters.countries"
              :regions-model="selectedFilters.regions" -->
              <BlogFilters
                :filters="filters"
                :blog-types-model="selectedFilters.types"
                :themes-model="selectedFilters.themes"
                :filter-reset="filterReset"
                @filter-change="updateSelectedFilters"
                @filter-reset="initFilterReset"
                />
            </el-col>
            <el-col :span="isFilterVisible ? 20 : 24">
              <BlogCardsList
                v-if="
                  changeBlogView &&
                  blogs &&
                  blogs.results &&
                  blogs.results.length > 0
                "
                :blogs="blogs.results && blogs.results"
                :span="$mq === 'lg' ? 8 : 6"
                :is-filter-visible="isFilterVisible"
                :list-type="viewType"
              />
              <div v-else class="text-center mt-100 no-records-found">
                <h4>
                  {{ noRecordsFound }}
                </h4>
              </div>
            </el-col>
          </mq-layout>
        </el-row>
      </div>

      <div>
        <el-row>
          <div class="container">
            <el-divider class="mt-4 mb-4" />
            <el-col :span="24">
              <div :class="isMobileLayout ? 'text-center' : 'text-right'">
                <Pagination
                  :current-page="currentPage"
                  :total-number-of-page="totalNumberOfPage"
                  @click-previous="clickPrevious"
                  @click-next="clickNext"
                />
              </div>
            </el-col>
          </div>
        </el-row>
      </div>

      <el-drawer
        id="drawer"
        ref="drawer"
        title="Filtrer"
        :visible.sync="isMobileFilterVisible"
        :direction="direction"
        :before-close="handleClose"
        :size="drawerSize"
        :class="isMobileFilterVisible && $mq == 'sm' && 'filter-full'"
      >
        <div class="filter--mobile">
          <!-- :authors-model="selectedFilters.authors" -->
          <!-- :countries-model="selectedFilters.countries"
          :regions-model="selectedFilters.regions" -->
          <BlogFilters
            :filters="filters"
            :blog-types-model="selectedFilters.types"
            :themes-model="selectedFilters.themes"
            :filter-reset="filterReset"
            @filter-change="updateSelectedFilters"
            @filter-reset="initFilterReset"
            />
          <div v-if="isMobileLayout" class="mt-16 mr-16 text-right">
            <el-button @click="handleClose">
              {{ cancelButton }}
            </el-button>
            <el-button type="primary">
              {{ filterButton }}
            </el-button>
          </div>
        </div>
      </el-drawer>
    </MainLayout>
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapState, mapActions, mapMutations } from "vuex";

import { ceil, forEach, isEmpty } from "@/utils/lodash";

import layoutUtils from "@/utils/layout-utils";

import FilterBar from "@/components/filter-bar.vue";
import MainLayout from "@/components/layout/main-layout.vue";
import Pagination from "@/components/pagination.vue";

import BlogCardsList from "./components/blog-cards-list.vue";
import BlogFilters from "./components/blog-filters.vue";

export default {
  components: {
    BlogCardsList,
    BlogFilters,
    FilterBar,
    MainLayout,
    Pagination,
  },
  props: {
    blogTypesModel: {
      type: Array,
      default: () => [],
    },
    page: {
      type: Number,
      default: 1,
    },
    attributesModel: {
      type: Array,
      default: () => [],
    },
    // authorsModel: {
    //   type: Array,
    //   default: () => [],
    // },
    textModel: {
      type: String,
      default: "",
    },
    // countriesModel: {
    //   type: Array,
    //   default: () => [],
    // },
    // regionsModel: {
    //   type: Array,
    //   default: () => [],
    // },

  },
  data() {
    return {
      filterCount: 0,
      selectedFilters: {
        types: [],
        themes: [],
        // authors: [],
        // countries: [],
        // regions: [],
      },
      isMobileFilterVisible: false,
      isFilterVisible: true,
      direction: "ltr",
      isMounted: false,
      filterReset: false,
      currentPage: 1,
      viewType: "tuiles",
      changeBlogView: true,
      isLoading: true,
      defaultShorting: '',
    };
  },
  computed: {
    ...mapState("blog", ["blogs", "filters"]),
    title() {
      return this.$i18n.t("blogs.blogsView.title");
    },
    drawerSize() {
      return this.innerWidth <= 414 ? "100%" : "414px";
    },
    cancelButton() {
      return this.$i18n.t("blogs.filters.button.cancel");
    },
    filterButton() {
      return this.$i18n.t("blogs.filters.button.filter");
    },
    noRecordsFound() {
      return this.$i18n.t("common.noRecordsFound");
    },
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
    numberOfBlogPerPage() {
      let numberOfblogs = 52;
      if (this.isMounted) {
        switch (this.$mq) {
          case "xs":
          case "sm":
          case "md":
            numberOfblogs = 20;
            break;
          case "lg":
            numberOfblogs = 51;
            break;
          default:
            break;
        }
      }
      return numberOfblogs;
    },
    totalNumberOfPage() {
      const numberOfPages =
        this.blogs && ceil(this.blogs.total / this.numberOfBlogPerPage);
      return numberOfPages != null && numberOfPages > 0 ? numberOfPages : 1;
    },
  },
  watch: {
    numberOfBlogPerPage() {
      this.redirectAfterPageChange();
    },
  },
  created() {
    this.resetState();
    this.fetchBlogFilters({});
    localStorage.setItem("viewType", 'tuiles');
  },
  mounted() {
    this.updateSelectedFilters({
      types: this.blogTypesModel,
      themes: this.attributesModel,
      // authors: this.authorsModel,
      // countries: this.countriesModel,
      // regions: this.regionsModel,
      
    });

    this.updateFiltersCount();

    // to make sure parent is mounted before sending values to children props (ex: map-state-filters)
    this.isMounted = true;

    this.$root.$on("viewType", (viewType) => {
      this.viewType = viewType;
      this.changeBlogView = false;
      this.$nextTick(() => {
        this.changeBlogView = true;
      });
    });
  },
  methods: {
    ...mapActions("blog", ["fetchBlogs", "fetchBlogFilters"]),
    ...mapMutations("blog", ["resetState"]),
    getBlogs(filters) {
        this.isLoading = true;
        if (!isEmpty(this.defaultShorting)) {
            var shorting = this.defaultShorting.split("=");
            if (shorting[0] === 'sortByDate') {
                filters.sortByDate = shorting[1];
            }
        }
        this.fetchBlogs({ filters })
            .then(() => {
                this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;

            });
      // this.isLoading = true;
      // this.fetchBlogs({
      //   filters,
      // }).then(() => {
      //   this.isLoading = false;
      // });
    },
    updateSelectedFilters: debounce(function(filters) {
      if (filters.types != null) {
        this.selectedFilters.types = filters.types;
      }

      if (filters.themes != null) {
        this.selectedFilters.themes = filters.themes;
      }

      // if (filters.authors != null) {
      //   this.selectedFilters.authors = filters.authors;
      // }
      // if (filters.countries != null) {
      //   this.selectedFilters.countries = filters.countries;
      // }

      // if (filters.regions != null) {
      //   this.selectedFilters.regions = filters.regions;
      // }

      this.validateCurrentPage();

      this.selectedFilters.page = this.currentPage;
      this.selectedFilters.size = this.numberOfBlogPerPage;

      this.updateFiltersCount();
      this.getBlogs(this.selectedFilters);
    }, 500),
    validateCurrentPage() {
      if (this.totalNumberOfPage && this.totalNumberOfPage < this.currentPage) {
        this.currentPage = this.totalNumberOfPage;
        return false;
      }

      return true;
    },
    updateFiltersCount() {
      const f = this.selectedFilters;

      this.filterCount = f.types.length + f.themes.length  
      // + f.countries.length +
      //   f.regions.length;
    },
    emitResetFilters() {
      this.filterReset = true;

      this.redirect({
        page: this.currentPage,
        size: this.numberOfBlogPerPage,
        type: [],
        // a: [],
        u: [],
        // c: [],
        // r: [],
      });
    },
    emitToggleFilter() {
      if (this.isMobileLayout) {
        this.isMobileFilterVisible = !this.isMobileFilterVisible;
      } else {
        this.isFilterVisible = !this.isFilterVisible;
      }
    },
    handleClose() {
      this.isMobileFilterVisible = false;
    },
    initFilterReset() {
      this.filterReset = false;
    },
    clickPrevious() {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
        this.redirectAfterPageChange();
      }
    },
    clickNext() {
      if (this.currentPage < this.totalNumberOfPage) {
        this.currentPage += 1;
        this.redirectAfterPageChange();
      }
    },
    redirectAfterPageChange() {
      this.updateSelectedFilters({
        page: this.currentPage,
        size: this.numberOfBlogPerPage,
        types: this.blogTypesModel,
        themes: this.attributesModel,
        // authors: this.authorsModel,
        // countries: this.countriesModel,
        // regions: this.regionsModel,
      });
      this.redirect(this.selectedFilters);
    },
    redirect(filters) {
      const initQuery = {
        ...this.$route.query,
        page: filters.page,
        size: filters.size,
        type: filters.types,
        // a: filters.themes,
        u: filters.authors,
        // c: filters.countries,
        // r: filters.regions,
      };

      const query = {};

      forEach(initQuery, (value, key) => {
        if (value != null) {
          query[key] = value;
        }
      });
      this.$router
        .push({
          query,
        })
        .catch(() => {});
    },
    shortedBy(shorting){
      this.defaultShorting = shorting;
      this.selectedFilters.page = 1;
      this.currentPage = 1;
      // if(!isEmpty(this.defaultShorting)){
        this.getBlogs(this.selectedFilters);
      // }
    }
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/variables.scss";

.title {
  color: $color-on-background;
}
</style>
